export const DEFAULT_ANIMATION_IN = 'animate__animated animate__fadeIn'

export const DEFAULT_ANIMATION_IN_SLOW =
  'animate__animated animate__fadeIn animate__slow'
